export default Object.freeze({
  Unknown: 0,
  Generic: 1,
  Windows: 2,
  Linux: 3,
  Unix: 4,
  IOS: 5,
  MacOS: 6,
  BlackBerry: 7,
  Android: 8,
  Symbian: 9,
});
